import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarCompetencia from '../../components/modal/ModalCadastrarCompetencia';
import ModalEditarCompetencia from '../../components/modal/ModalEditarCompetencia';
import ModalExcluirCompetencia from '../../components/modal/ModalExcluirCompetencia';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function Competencia() {
    const { Success, Error, openModal, setOpenModal, CompetenciasConsulta, ListaCompetenciaConsulta, loading, modalEditarCompetencia, setModalEditarCompetencia, setEdicaoCompetencia, setCompetenciaAtualKey, modalExcluirCompetencia, setModalExcluirCompetencia, InativarCompetencia, Permissao, ListaFiltroCompetencia, totalRegistrosCompetencia, filtroCompetencia, totalRegistrosFiltroCompetencia } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCompetencia = (props) => {
        setModalEditarCompetencia(true)
        setCompetenciaAtualKey(props.key)
        setEdicaoCompetencia(props)
    }

    const DeletarCompetencia = (props) => {
        setCompetenciaAtualKey(props.key)
        setModalExcluirCompetencia(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroCompetencia(searchTerm, currentPage, pageSize);
        } else {
            ListaCompetenciaConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroCompetencia : totalRegistrosCompetencia;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar competência'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarCompetencia &&
                <ModalEditarCompetencia currentPage={currentPage} />
            }
            {modalExcluirCompetencia &&
                <ModalExcluirCompetencia currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarCompetencia closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar competência</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Competências cadastradas</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroCompetencia : CompetenciasConsulta}
                        columns={[
                            { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarCompetencia(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditCompetencia(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarCompetencia(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroCompetencia(term, 1, 10);
                            } else {
                                ListaCompetenciaConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Competencia;